type RouteHandler = (params?: Record<string, string>) => void;

export class Router {
  private routes = new Map<string, RouteHandler>();
  private current = '';

  on(path: string, handler: RouteHandler): this {
    this.routes.set(path, handler);
    return this;
  }

  navigate(path: string): void {
    window.location.hash = path;
  }

  currentRoute(): string {
    return this.current;
  }

  init(): void {
    const handle = () => {
      const hash = window.location.hash.slice(1) || 'home';
      const [path, ...rest] = hash.split('/');
      const params: Record<string, string> = {};
      if (rest.length) params.id = rest.join('/');

      if (this.current !== path) {
        this.current = path;
        const handler = this.routes.get(path) ?? this.routes.get('*');
        if (handler) handler(params);
      }
    };

    window.addEventListener('hashchange', handle);
    handle();
  }
}
